import styled from 'styled-components'

import { TabPanesContentContainerStyled } from '@webapp/components/TabPanes'
import { TabPanesTabsContainerStyled } from '@webapp/components/TabPanes/styles/TabPanesTabsContainerStyled'

export const ExpenseReviseViewStyled = styled.div`
  ${TabPanesContentContainerStyled} {
    padding-top: 0;
  }

  ${TabPanesTabsContainerStyled} {
    display: none;
  }
`
